import { render, staticRenderFns } from "./WatermarkDev.vue?vue&type=template&id=f35ad8e0&scoped=true"
import script from "./WatermarkDev.vue?vue&type=script&lang=js"
export * from "./WatermarkDev.vue?vue&type=script&lang=js"
import style0 from "./WatermarkDev.vue?vue&type=style&index=0&id=f35ad8e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35ad8e0",
  null
  
)

export default component.exports